import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ConsultOurAdvisors from "./sections/ConsultOurAdvisors";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ConsultOurAdvisors />
      <Footer />
    </div>;
}